import React from 'react';
import { useHistory } from 'react-router-dom';
import * as s from './styled-breadcumb';

// SVG inline pra seta de voltar — fica nitida em qualquer DPR (vs char
// `←`), aceita stroke do CSS (currentColor) e nao depende de fonte do
// sistema. Stroke-linecap: round da o acabamento mais polido.
const BackArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

// SVG inline pra chevron separador — substitui o caractere `›` que tinha
// alinhamento/altura inconsistentes entre fontes.
const ChevronIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="9 6 15 12 9 18" />
  </svg>
);

const Breadcumb = ({ paths, props }) => {
  const history = useHistory();

  const navigateTo = (path) => {
    if (path.goBack) {
      history.goBack();
      return;
    }
    if (path.action) path.action();
    if (props) {
      history.push(path.to, { ...props });
      return;
    }
    history.push(path.to);
  };

  const hasParent = paths.length > 1;
  const parentPath = hasParent ? paths[paths.length - 2] : null;

  return (
    <s.Container className="style-container-aplicacao">
      {parentPath && (
        <s.BackArrow
          type="button"
          aria-label={`Voltar para ${parentPath.pathName}`}
          title={`Voltar para ${parentPath.pathName}`}
          onClick={() => navigateTo(parentPath)}
        >
          <BackArrowIcon />
        </s.BackArrow>
      )}
      {paths.map((path, index) => {
        const isLast = index === paths.length - 1;
        return (
          <s.Path
            key={path.pathName}
            onClick={() => {
              if (isLast) return;
              navigateTo(path);
            }}
          >
            {path.pathName}
            {!isLast && (
              <span>
                <ChevronIcon />
              </span>
            )}
          </s.Path>
        );
      })}
    </s.Container>
  );
};

export default Breadcumb;
